import { type Brand, BRAND } from '@/lib/cms/config';
import { getBaseUrl } from '@/lib/seo/constants';
import { searchPaths } from '@/lib/paths';

/** Contentful Page slug for boutiques listing CMS (hero + placeholders in Content order). */
export const BOUTIQUES_PAGE_CMS_SLUG = process.env.BOUTIQUES_PAGE_CMS_SLUG ?? 'gallet-stores';

/** Contentful Page slug for boutique detail pages (gallet-store-detail). */
export const BOUTIQUE_DETAIL_PAGE_CMS_SLUG =
  process.env.BOUTIQUE_DETAIL_PAGE_CMS_SLUG ?? 'gallet-store-detail';

/** CMSRenderer extraData: FindAStore uses the boutique split panel layout. */
export const BOUTIQUE_CMS_EXTRA_DATA = {
  findAStoreLayout: 'boutique-panel',
} as const;

const BREITLING_BOUTIQUE_IMAGE_URL =
  'https://www.breitling.com/media/image/1/gallery_square_700/asset-version-afd23a6c5c/breitling-boutique.jpg';

export interface BoutiqueFindCtaDefaults {
  storeLocatorUrl: string;
  imageUrl: string;
}

/**
 * Brand-specific fallbacks for the boutiques find-CTA when CMS values are missing.
 *
 * Example Input:
 * brand = "gallet"
 *
 * Example Output:
 * { storeLocatorUrl: "https://www.gallet.com/search/stores", imageUrl: "/images/placeholder.svg" }
 */
export function getBoutiqueFindCtaDefaults(brand: Brand = BRAND): BoutiqueFindCtaDefaults {
  if (brand === 'breitling') {
    return {
      storeLocatorUrl: 'https://store.breitling.com/',
      imageUrl: BREITLING_BOUTIQUE_IMAGE_URL,
    };
  }

  return {
    storeLocatorUrl: `${getBaseUrl('gallet')}${searchPaths.stores()}`,
    imageUrl: '/images/placeholder.svg',
  };
}
